import { useEffect, useRef, useState } from "react"
import { BsPlus, BsDash } from "react-icons/bs"
import { useTranslation } from "react-i18next"

//
// @Nick
// This is not supposed to be any. help me. Im realy bad at typescripting
//

export function Detail({ descriptionHTML }: any) {
    const { t } = useTranslation(["common"])

    const [ isOpen, setIsOpen ] = useState(false)
    useEffect(() => { isOpen ?  handleOpen() : handleClose() }, [ isOpen ])

    const collapableRef = useRef<HTMLDivElement>(null)

    const handleOpen = () => {
        if (collapableRef.current) {
            collapableRef.current.style.gridTemplateRows = "1fr";
        }
    }

    const handleClose = () => {
        if (collapableRef.current) {
            collapableRef.current.style.gridTemplateRows = "0fr";
        }
    }
    
    return (
        <div className="detail">
            <div className="detail__wrapper" ref={ collapableRef }>
                <div className="detail__wrapper-collapse" dangerouslySetInnerHTML={{ __html: descriptionHTML }}></div>
            </div>
            <div className="detail__trigger" onClick={ () => setIsOpen( !isOpen ) }>
                { isOpen && <BsDash strokeWidth={1} /> }
                { !isOpen && <BsPlus strokeWidth={1} /> }
                <p>{ isOpen ? t("button__detail_isclosed") : t("button__detail_isopen") }</p>
            </div>
        </div>
    )
}